import {onLoad} from "../base/onLoad";

onLoad(() => {
    const menu_color_triggers = document.querySelectorAll('[data-menu-color]');

    if (menu_color_triggers.length < 1) {
        return;
    }

    const background_items = document.querySelectorAll('[data-menu-color-default]');

    function changeMenuColor(color: string | null = null) {
        background_items.forEach((item) => {
            const element = item as HTMLElement;
            const default_color = element.getAttribute('data-menu-color-default');
            element.style.backgroundColor = color || default_color || '';
        });
    }

    window.addEventListener('scroll', () => {
        const scroll = window.scrollY;

        const topOffset = 100;
        const bottomOffset = window.innerHeight / 2;

        const past: HTMLElement[] = [];

        menu_color_triggers.forEach((trigger) => {
            const _trigger = trigger as HTMLElement;

            const scrollTop = _trigger.offsetTop;
            const scrollBottom = scrollTop + _trigger.offsetHeight;

            const scrolledPast = scroll > scrollTop - topOffset;
            const stillIn = scroll < scrollBottom - bottomOffset;

            if (scrolledPast && stillIn) {
                past.push(_trigger);
            }
        });

        const lastPast = past[past.length - 1];

        if (lastPast) {
            const color = lastPast.getAttribute('data-menu-color');
            changeMenuColor(color);
        } else {
            changeMenuColor();
        }
    });
});